import request from '@/utils/ucenter_request'
import payRequest from '@/utils/pay_request'
import bbsRequest from '@/utils/bbs_request'
import qs from "qs";

// 修改头像
export function updateAvatar(params) {
  return request({
      url: '/personal/Myinfo/setAvatar',
      method: 'get',
      params: params
  })
}
// 修改用户信息
export function updateRegistInfo(params) {
  return request({
    url: '/personal/Myinfo/regisInfo',
    method: 'get',
    params: params
  })
}
// 获取用户注册信息
export function getRegisInfo(params) {
  return request({
    url: '/personal/Myinfo/getRegisInfo',
    method: 'get',
    params: params
  })
}
// 获取省市地区
export function getAgreement(params) {
  return payRequest({
    url: 'pay/order/getPayProtocol',
    method: 'get',
    params: params
  })
}
// 获取省市地区
export function getDistrict(params) {
  return payRequest({
    url: '/pay/address/getDistrict',
    method: 'get',
    params: params
  })
}
// 推荐可关注的人
export function followList(params) {
  return request({
    url: '/personal/Task/followList',
    method: 'get',
    params: params
  })
}
// 添加关注
export function addFollow(params) {
  return bbsRequest({
    url: '/user/follow/follow',
    method: 'get',
    params: params
  })
}

// 获取专业
export function getMajorList(params) {
  return request({
    url: '/personal/Myinfo/getMajorList',
    method: 'get',
    params: params
  })
}

// 获取筑龙币记录
export function myInteg(params) {
  return request({
    url: '/personal/Myinfo/myInteg',
    method: 'get',
    params: params
  })
}


// 新手任务列表接口
export function newTaskIndex(params) {
  return request({
    url: '/personal/Task/index',
    method: 'get',
    params: params
  })
}

// 完成关注任务领奖接口
export function followGetScore(params) {
  return request({
    url: '/personal/Task/followGetScore',
    method: 'get',
    params: params
  })
}

// 当天签到
export function signToday(params) {
  return request({
    url: '/api/user/sign',
    method: 'get',
    params: params
  })
}
// 用户协议
export function getPayProtocol(params) {
  return payRequest({
    url: 'pay/order/getPayProtocol',
    method: 'get',
    params: params
  })
}
/**
 * [获取注册信息-新接口-林杰]
 **/
export function getNewRegisInfo() {
  return request({
    url: '/personal/Myinfo/getNewRegisInfo',
    method: 'get'
  })
}
/**
 * [获取注册信息-新接口-林杰]
 **/
export function newRegisInfo(params) {
  return request({
    url: '/personal/Myinfo/newRegisInfo',
    method: 'post',
    contentType: 'application/x-www-from-urlencoded',
    data: qs.stringify(params)
  })
}
// 学历
export function getEduConfig(params) {
  return request({
    url: '/personal/Myinfo/getEduBackList',
    method: 'post',
    data: qs.stringify(params)
  })
}
